import React, { useState } from "react";
import { Eye, Download } from "lucide-react";
import { Dialog } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Tasks from "../assets/images/Tasks.svg";
import Deals from "../assets/images/Deals.svg";
import Leads from "../assets/images/Leads.svg";
import Default from "../assets/images/Default.svg";
import UpperArrow from "../assets/images/UpperArrow.svg";
import {
  useFetchCustomerDashboardQuery,
  useFetchCustomerDocumentDataQuery,
  useFetchCustomerNotesTableDataQuery,
} from "../utils/customer/customerTaskTable";
import NotesContentPreivew from "./GlobalFeature/Table/ExtraComponent/NotesContentPreivew";
import DocumentIcon from "../utils/utilityFunctions/iconUtility";
import { getHexWithOpacity, getTitleCase } from "../utils/utilityFunctions/stringUtility";
import { getCompanyId, getOrganizationId, getUserId, getUserToken } from "../utils/utilityFunctions/localServices";

const categoriesList = {
  task: {
    icon: Tasks,
    color: "#5A6ACF",
  },
  deal: {
    icon: Deals,
    color: "#0637A1",
  },
  lead: {
    icon: Leads,
    color: "#0B9696",
  },
};

const File = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="181" viewBox="0 0 327 181" fill="none" className="w-full">
      <path
        d="M253.556 90.0562C253.556 139.793 213.237 180.112 163.5 180.112C113.763 180.112 73.4438 139.793 73.4438 90.0562C73.4438 40.3195 113.763 0 163.5 0C213.237 0 253.556 40.3195 253.556 90.0562Z"
        fill="#F8FBFF"
      />
      <path
        d="M19.3327 33.9158C19.3327 32.0855 20.8166 30.6016 22.6469 30.6016H304.905C306.736 30.6016 308.22 32.0855 308.22 33.9158V146.046C308.22 147.876 306.736 149.36 304.905 149.36H22.6469C20.8165 149.36 19.3327 147.876 19.3327 146.046V33.9158Z"
        fill="#F2F8FE"
      />
      <path
        d="M0 56.5627C0 54.7324 1.48381 53.2486 3.31419 53.2486H323.686C325.516 53.2486 327 54.7324 327 56.5628V123.399C327 125.229 325.516 126.713 323.686 126.713H3.31418C1.48381 126.713 0 125.229 0 123.399V56.5627Z"
        fill="white"
      />
      <path
        d="M8.83788 64.7094C8.83788 63.2608 10.0122 62.0864 11.4609 62.0864H64.2132C65.6618 62.0864 66.8362 63.2608 66.8362 64.7094V115.252C66.8362 116.701 65.6618 117.875 64.2132 117.875H11.4609C10.0122 117.875 8.83788 116.701 8.83788 115.252V64.7094Z"
        fill="#E0F1FF"
      />
      <path
        d="M75.674 68.4386C75.674 64.9304 78.5179 62.0864 82.0262 62.0864H249.945C253.453 62.0864 256.297 64.9304 256.297 68.4386C256.297 71.9468 253.453 74.7908 249.945 74.7908H82.0262C78.5179 74.7908 75.674 71.9468 75.674 68.4386Z"
        fill="#E0F1FF"
      />
      <path
        d="M75.6739 89.9807C75.6739 86.4725 78.5179 83.6285 82.0261 83.6285H220.117C223.626 83.6285 226.469 86.4725 226.469 89.9807C226.469 93.489 223.626 96.3329 220.117 96.3329H82.0261C78.5179 96.3329 75.6739 93.489 75.6739 89.9807Z"
        fill="#F2F8FE"
      />
      <path
        d="M75.6739 111.523C75.6739 108.015 78.5179 105.171 82.0261 105.171H205.756C209.264 105.171 212.108 108.015 212.108 111.523C212.108 115.031 209.264 117.875 205.756 117.875H82.0261C78.5179 117.875 75.6739 115.031 75.6739 111.523Z"
        fill="#F2F8FE"
      />
    </svg>
  );
};

const ServiceFile = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217 206" fill="none" className="w-full h-full">
      <path
        d="M206 103C206 159.885 159.885 206 103 206C46.1147 206 0 159.885 0 103C0 46.1147 46.1147 0 103 0C159.885 0 206 46.1147 206 103Z"
        fill="#F8FBFF"
      />
      <path
        d="M107 32C107 28.6863 109.686 26 113 26H211C214.314 26 217 28.6863 217 32V173C217 176.314 214.314 179 211 179H113C109.686 179 107 176.314 107 173V32Z"
        fill="white"
      />
      <path
        d="M121 43C121 41.3431 122.343 40 124 40H200C201.657 40 203 41.3431 203 43V101C203 102.657 201.657 104 200 104H124C122.343 104 121 102.657 121 101V43Z"
        fill="#E0F1FF"
      />
      <path
        d="M126 118C126 114.686 128.686 112 132 112H192C195.314 112 198 114.686 198 118C198 121.314 195.314 124 192 124H132C128.686 124 126 121.314 126 118Z"
        fill="#E0F1FF"
      />
      <path
        d="M132 138.5C132 135.462 134.462 133 137.5 133H186.5C189.538 133 192 135.462 192 138.5C192 141.538 189.538 144 186.5 144H137.5C134.462 144 132 141.538 132 138.5Z"
        fill="#F2F8FE"
      />
      <path
        d="M134.5 159C134.5 155.686 137.186 153 140.5 153H183.5C186.814 153 189.5 155.686 189.5 159C189.5 162.314 186.814 165 183.5 165H140.5C137.186 165 134.5 162.314 134.5 159Z"
        fill="#F2F8FE"
      />
      <path
        d="M3 43C3 41.3431 4.34315 40 6 40H82C83.6569 40 85 41.3431 85 43V101C85 102.657 83.6569 104 82 104H6C4.34315 104 3 102.657 3 101V43Z"
        fill="#E0F1FF"
      />
      <path
        d="M8 118C8 114.686 10.6863 112 14 112H74C77.3137 112 80 114.686 80 118C80 121.314 77.3137 124 74 124H14C10.6863 124 8 121.314 8 118Z"
        fill="#E0F1FF"
      />
      <path
        d="M14 138.5C14 135.462 16.4624 133 19.5 133H68.5C71.5376 133 74 135.462 74 138.5C74 141.538 71.5376 144 68.5 144H19.5C16.4624 144 14 141.538 14 138.5Z"
        fill="#F2F8FE"
      />
      <path
        d="M16.5 159C16.5 155.686 19.1863 153 22.5 153H65.5C68.8137 153 71.5 155.686 71.5 159C71.5 162.314 68.8137 165 65.5 165H22.5C19.1863 165 16.5 162.314 16.5 159Z"
        fill="#F2F8FE"
      />
    </svg>
  );
};

const Dashboard = ({ customerId }) => {
  const { data } = useFetchCustomerDashboardQuery({ token: getUserToken(), customer_id: customerId });
  console.log("👉 Customer Dashboard Data 👈", data);

  const { data: notesData } = useFetchCustomerNotesTableDataQuery({
    customerId: customerId,
    limit: 15,
    page: 1,
    type: "Tracking",
  });

  const { data: documentsData } = useFetchCustomerDocumentDataQuery({
    token: getUserToken(),
    customerId: customerId,
    folderId: "",
    userId: getUserId(),
    companyId: getCompanyId(),
    orgId: getOrganizationId(),
    templateId: "",
  });

  const defaultTemplate = {
    task: {
      count: 0,

      completed: 0,

      inProgress: 0,

      overdue: 0,
    },

    deal: {
      count: 0,

      completed: 0,

      inProgress: 0,

      overdue: 0,
    },

    lead: {
      count: 0,

      completed: 0,

      inProgress: 0,

      overdue: 0,
    },
  };

  // const categories =
  //   Object.values(data?.data?.categories || {}).length > 0
  //     ? data?.data?.categories
  //     : {
  //         tasks: {
  //           count: 0,

  //           completed: 0,

  //           inProgress: 0,

  //           overdue: 0,
  //         },

  //         deals: {
  //           count: 0,

  //           completed: 0,

  //           inProgress: 0,

  //           overdue: 0,
  //         },

  //         leads: {
  //           count: 0,

  //           completed: 0,

  //           inProgress: 0,

  //           overdue: 0,
  //         },

  //         totalProjects: 0,
  //       };
  const categories =
    Object.values(data?.data?.categories || {}).length > 0
      ? { ...defaultTemplate, ...data?.data?.categories }
      : defaultTemplate;
  console.log("Categories data - ", categories);
  const myAssignments = Object.values(data?.data?.myAssignments || {}).length > 0 ? data?.data?.myAssignments : {};
  const recent = Object.values(data?.data?.recent || {}).length > 0 ? data?.data?.recent : {};
  const documents = documentsData?.data?.data || [];
  const escalations = data?.data?.escalations || [];
  const notes = notesData?.data?.notes || [];
  const services = data?.data?.services?.length > 0 ? data?.data?.services : [];

  const totalTasks = myAssignments?.completed + myAssignments?.inProgress + myAssignments?.overdue || 0;
  const completedWidth = ((myAssignments?.completed || 0) / totalTasks) * 100;
  const inProgressWidth = ((myAssignments?.inProgress || 0) / totalTasks) * 100;
  const overdueWidth = ((myAssignments?.overdue || 0) / totalTasks) * 100;

  const [noteId, setNoteId] = useState(null);
  const [isNotePreviewOpen, setIsNotePreviewOpen] = useState(false);

  const handlePreviewData = (id) => {
    setNoteId((prev) => (prev === id ? null : id));
    setIsNotePreviewOpen((prev) => !prev);
  };

  const navigate = useNavigate();

  const excludedKeys = ["task", "deal", "lead"];

  return (
    <div className="p-1 bg-white grow min-h-0 text-gray-800">
      {/* Categories Section */}
      <div className="flex flex-nowrap gap-6 mb-8 overflow-x-scroll scrollbar-hidden">
        {Object.entries(categoriesList)?.map(([key, value], idx) =>
          typeof value === "object" ? (
            <div
              key={key}
              style={{ backgroundColor: getHexWithOpacity(value.color, 5) }}
              className={`flex flex-col gap-3 w-3/4 md:w-[29%] shrink-0 grow shadow hover:shadow-card rounded-xl p-5 border border-[#F3F3F3]`}
            >
              <div className="flex justify-between">
                <div className="flex gap-6">
                  {/* Div Svg */}
                  <div
                    style={{ border: `1px solid ${getHexWithOpacity(value.color, 20)}` }}
                    className="w-12 h-12 rounded-full bg-white flex justify-center items-center"
                  >
                    <img src={value.icon} alt="svg" />
                  </div>
                  {/* Value Count and Heading */}
                  <div className="flex flex-col">
                    <span style={{ color: value.color }} className={`text-2xl font-bold`}>
                      {categories[key]?.count || 0}
                    </span>
                    <h3 className="text-sm font-medium mb-2 text-[#13131399] capitalize">
                      {/* {key.replace("total", "Total ")} */}
                      Total {key}
                    </h3>
                  </div>
                </div>
                {/* Side Arrow */}
                <div
                  style={{ backgroundColor: value.color }}
                  className="w-5 h-5 rounded-full flex justify-center items-center"
                >
                  <img src={UpperArrow} alt="arrow" />
                </div>
              </div>
              <div className="flex justify-between text-sm">
                <span className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-green-400 rounded-full"></span>
                  <span className="text-[#13131399]">
                    Completed: <span className="text-[#131313] font-medium">{categories[key]?.completed || 0}</span>
                  </span>
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                  <span className="text-[#13131399]">
                    In Progress: <span className="text-[#131313] font-medium">{categories[key]?.inProgress || 0}</span>
                  </span>
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-2 h-2 bg-red-600 rounded-full"></span>
                  <span className="text-[#13131399]">
                    Overdue: <span className="text-[#131313] font-medium">{categories[key]?.overdue || 0}</span>
                  </span>
                </span>
              </div>
            </div>
          ) : null
        )}
        {Object.entries(categories)?.map(([key, value], idx) =>
          typeof value === "object" && !excludedKeys.includes(key) ? (
            <div
              key={key}
              style={{ backgroundColor: getHexWithOpacity("#6829FA", 5) }}
              className={`flex flex-col gap-3 w-3/4 md:w-[29%] shrink-0 grow shadow hover:shadow-card rounded-xl p-5 border border-[#F3F3F3]`}
            >
              <div className="flex justify-between">
                <div className="flex gap-6">
                  {/* Div Svg */}
                  <div
                    style={{ border: `1px solid ${getHexWithOpacity("#6829FA", 20)}` }}
                    className="w-12 h-12 rounded-full bg-white flex justify-center items-center"
                  >
                    <img src={Default} alt="svg" />
                  </div>
                  {/* Value Count and Heading */}
                  <div className="flex flex-col">
                    <span style={{ color: "#6829FA" }} className={`text-2xl font-bold`}>
                      {value?.count || 0}
                    </span>
                    <h3 className="text-sm font-medium mb-2 text-[#13131399] capitalize">
                      {/* {key.replace("total", "Total ")} */}
                      Total {key}
                    </h3>
                  </div>
                </div>
                {/* Side Arrow */}
                <div
                  style={{ backgroundColor: "#6829FA" }}
                  className="w-5 h-5 rounded-full flex justify-center items-center"
                >
                  <img src={UpperArrow} alt="arrow" />
                </div>
              </div>
              <div className="flex justify-between text-sm">
                <span className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-green-400 rounded-full"></span>
                  <span className="text-[#13131399]">
                    Completed: <span className="text-[#131313] font-medium">{value?.completed || 0}</span>
                  </span>
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                  <span className="text-[#13131399]">
                    In Progress: <span className="text-[#131313] font-medium">{value?.inProgress || 0}</span>
                  </span>
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-2 h-2 bg-red-600 rounded-full"></span>
                  <span className="text-[#13131399]">
                    Overdue: <span className="text-[#131313] font-medium">{value?.overdue || 0}</span>
                  </span>
                </span>
              </div>
            </div>
          ) : null
        )}
      </div>

      {/* Main Section with Assignments, Recent, Documents, Notes, Escalations, Services */}
      <div className="grid grid-cols-1 lg:grid-cols-[64.9%_34%] gap-6">
        {/* Left Side */}
        <div className="space-y-6">
          {Object.values(myAssignments || {}).length > 0 && (
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-semibold">My Assignments</h2>
              {/* <button className="text-sm text-[#131313CC] hover:underline">+ Add New Project</button> */}
            </div>
          )}

          {/* Assignments */}
          {Object.values(myAssignments || {}).length > 0 && (
            <div className="bg-white rounded-xl shadow hover:shadow-card p-6">
              <div className="flex justify-between items-center gap-10 mb-4">
                <div className="flex flex-col items-center p-2 pr-10 border-r border-dashed border-[#ECECEC]">
                  <p className="text-[#13131399] text-lg font-semibold whitespace-nowrap">Total Projects</p>
                  <span className="text-[#2999BC] text-4xl font-semibold">{myAssignments?.totalProjects || 0}</span>
                </div>
                <div className="flex-1 flex flex-col gap-4">
                  <div className="flex gap-2">
                    <h3 className="text-[16px] font-medium text-[#13131399]">Total Tasks</h3>
                    <span className="text-[16px] font-medium text-[#131313]">
                      {myAssignments?.completed + myAssignments?.inProgress + myAssignments?.overdue || 0}
                    </span>
                  </div>
                  <div className="relative flex bg-[#F2F8FE] rounded-sm h-9 overflow-hidden">
                    <div className="h-full bg-green-400" style={{ width: `${completedWidth}%` }}></div>
                    <div className="h-full bg-orange-500" style={{ width: `${inProgressWidth}%` }}></div>
                    <div className="h-full bg-red-600" style={{ width: `${overdueWidth}%` }}></div>
                  </div>
                  <div className="flex justify-between text-sm text-gray-600 mt-2">
                    <span className="flex items-center gap-1 text-green-400">
                      <span className="w-2 h-2 bg-green-400 rounded-full"></span>Completed:{" "}
                      {myAssignments?.completed || 0}
                    </span>
                    <span className="flex items-center gap-1 text-orange-500">
                      <span className="w-2 h-2 bg-orange-500 rounded-full"></span>In Progress:{" "}
                      {myAssignments?.inProgress || 0}
                    </span>
                    <span className="flex items-center gap-1 text-red-500">
                      <span className="w-2 h-2 bg-red-600 rounded-full"></span>Overdue: {myAssignments?.overdue || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Recent & Documents Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Recent */}
            <div
              className={`relative bg-white rounded-xl shadow hover:shadow-card ${Object.values(myAssignments || {}).length === 0 ? "h-[660px]" : "h-[440px]"} overflow-auto scrollbar-hidden`}
            >
              <h3 className="sticky top-0 text-lg font-semibold p-5 mb-5 bg-white border-b border-b-[#00000013]">
                Recent
              </h3>
              <div
                className={`px-5 w-full ${Object.values(recent).length === 0 ? (Object.values(myAssignments || {}).length === 0 ? "h-[580px]" : "h-[369px]") : ""} flex flex-col items-center justify-center`}
              >
                {Object.values(recent).length > 0 ? (
                  Object.entries(recent).map(([_, item], i) => (
                    <div key={i} className="border-b border-dashed border-[#F3F3F3] rounded-lg p-4 mb-6 w-full">
                      <div className="flex justify-between mb-2">
                        {/* <h4 className="font-semibold text-gray-700">{item.section}</h4>
                      <p className="text-sm text-gray-500">
                        Records: {item.totalRecords} | Tasks: {item.totalTasks}
                      </p> */}
                        <h4 className="font-semibold text-gray-700">{item.template_name}</h4>
                        <p className="text-sm text-gray-500">
                          Records: {item.linked_task_count} | Tasks: {item.count}
                        </p>
                      </div>
                      <p className="text-xs text-gray-400">
                        {new Date(item.created_at).toLocaleDateString()}{" "}
                        {new Date(item.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} • By{" "}
                        {item.created_by}
                      </p>
                      {/* {item.notes.map((note) => (
                      <div key={note.id} className="mb-3">
                        <p className="text-sm text-gray-600 mb-1">{note.content}</p>
                        <p className="text-xs text-gray-400">
                          {new Date(note.createdAt).toLocaleDateString()}{" "}
                          {new Date(note.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} • By{" "}
                          {note.author}
                        </p>
                      </div>
                    ))} */}
                    </div>
                  ))
                ) : (
                  <div className="flex flex-col items-center justify-center gap-2 w-full h-[369px]">
                    <File />
                    <div className="flex flex-col gap-1 items-center justify-center">
                      <p className="text-[#131313CC] font-semibold text-sm">You didn't have any Pinned Modules</p>
                      <p className="text-[#131313CC] text-xs">List of pinned modules will be diplayed here.</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Documents */}
            <div
              className={`relative bg-white rounded-xl shadow hover:shadow-card ${Object.values(myAssignments || {}).length === 0 ? "h-[660px]" : "h-[440px]"} overflow-auto scrollbar-hidden`}
            >
              <div className="sticky top-0 w-full flex justify-between items-center mb-3 p-5 bg-white border-b border-b-[#00000013]">
                <h3 className="text-lg font-semibold">Documents</h3>
                {customerId && documents.filter((doc) => doc.type === "file").length > 0 && (
                  <button
                    type="button"
                    className="text-sm text-blue-600 hover:underline"
                    onClick={() => navigate(`/customer/${customerId}/customer-relationship/document`)}
                  >
                    View All
                  </button>
                )}
              </div>
              <ul
                className={`space-y-3 px-5 w-full ${documents.length === 0 ? (Object.values(myAssignments || {}).length === 0 ? "h-[580px]" : "h-[369px]") : ""} flex flex-col items-center justify-center`}
              >
                {documents.filter((doc) => doc.type === "file").length > 0 ? (
                  documents
                    .filter((doc) => doc.type === "file")
                    .map((doc, i) => (
                      // documents.map((doc, i) => (
                      <li
                        key={i}
                        className="flex justify-between items-center border-b border-dashed border-[#F3F3F3 px-3 py-3 rounded-md hover:bg-blue-50 group w-full"
                      >
                        <div className="flex flex-col gap-1 w-full">
                          <div className="flex justify-between items-center mb-1">
                            <div className="flex items-center gap-2 text-gray-700">
                              <DocumentIcon type={doc.type} filename={doc.display_name} />
                              <span>{doc.display_name}</span>
                            </div>
                            <div className="flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity">
                              <button className="p-1 text-green-400 hover:text-green-500">
                                <Download
                                  size={16}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(doc.access_sas_link);
                                  }}
                                />
                              </button>
                            </div>
                          </div>
                          <p className="text-xs text-gray-400">
                            {new Date(doc.created_at).toLocaleDateString()}{" "}
                            {new Date(doc.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} •
                            By {doc.created_by}
                          </p>
                        </div>
                      </li>
                    ))
                ) : (
                  <div className="flex flex-col items-center justify-center gap-2 w-full h-[369px]">
                    <File />
                    <div className="flex flex-col gap-1 items-center justify-center">
                      <p className="text-[#131313CC] font-semibold text-sm">You didn't have any Documents</p>
                      <p className="text-[#131313CC] text-xs">List of documents will be diplayed here.</p>
                    </div>
                  </div>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="space-y-6 h-fit p-2 max-h-[670px] overflow-auto scrollbar-hidden">
          {/* Escalations */}
          {escalations.length > 0 && (
            <div
              className={`relative bg-red-50 border border-red-200 rounded-xl shadow hover:shadow-card h-[250px] overflow-auto scrollbar-hidden`}
            >
              <h3 className="sticky top-0 text-lg font-semibold text-red-600 mb-3 px-5 py-4 bg-red-50 border-b border-b-red-200">
                All Escalations ({escalations?.length})
              </h3>
              <div
                className={`px-5 w-full ${escalations.length === 0 && "h-[150px]"} flex justify-center items-center gap-2`}
              >
                {escalations.length > 0 ? (
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left border-b text-gray-600">
                        <th className="py-1">Name</th>
                        <th className="py-1">Date</th>
                        <th className="py-1">Assigned By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {escalations.map((e, i) => (
                        // <tr key={i} className="border-b border-red-100 last:border-none hover:bg-red-100">
                        <tr key={i} className="hover:bg-red-100">
                          <td className="py-1 font-medium text-gray-700">{e?.name}</td>
                          <td className="py-1 text-gray-600">{e?.date}</td>
                          <td className="py-1 text-gray-600">{e?.assignedBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="flex flex-col items-center justify-center gap-1 w-full">
                    <p className="text-[#131313CC] font-semibold text-sm">You didn't have any Escalactions</p>
                    <p className="text-[#131313CC] text-xs">List of escalations will be diplayed here.</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Notes */}
          <div
            className={`relative bg-white rounded-xl border hover:shadow-card border-gray-200 shadow ${notes.length === 0 ? "h-[350px]" : "h-[300px]"} overflow-auto scrollbar-hidden`}
          >
            <div className="sticky top-0 flex justify-between items-center mb-5 bg-white p-5 border-b border-b-[#00000013]">
              <h3 className="text-lg font-semibold">Notes ({notes.length})</h3>
              {customerId && notes.length > 0 && (
                <button
                  type="button"
                  className="text-sm text-blue-600 hover:underline"
                  onClick={() => navigate(`/customer/${customerId}/customer-relationship/notes`)}
                >
                  Show All
                </button>
              )}
            </div>
            <div
              className={`px-5 w-full ${notes.length === 0 && "h-[270px]"} flex flex-col justify-center items-center gap-2`}
            >
              {notes.length > 0 ? (
                notes.map((note, i) => {
                  const date = new Date(note.created_at);
                  const day = date.getDate();
                  const month = date.toLocaleString("en-US", { month: "long" });
                  const year = date.getFullYear();
                  let hours = date.getHours();
                  const minutes = date.getMinutes().toString().padStart(2, "0");
                  const ampm = hours >= 12 ? "PM" : "AM";
                  const formatted = `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
                  return (
                    <div key={i} className="w-full flex justify-between items-start rounded-l p-4 mb-6">
                      <div className="flex flex-col gap-1">
                        <h4 className="font-semibold text-gray-700">
                          {getTitleCase(note.notes_title || `Notes - ${day} ${month} ${year}`)}
                        </h4>
                        {/* <p className="text-sm text-gray-700">{note.notes_body}</p> */}
                        {/* <div className="flex gap-2 flex-wrap mb-2">
                          {note.attachments.map((a, j) => (
                            <div key={j} className="flex items-center gap-1 bg-[#F6F6F6] px-5 py-2 rounded-full text-xs">
                              <FileText color="red" size={16} />
                              <span>{a.fileName}</span>
                            </div>
                          ))}
                        </div> */}
                        <p className="text-xs text-gray-400">
                          {formatted} • By {note.created_by}
                        </p>
                      </div>
                      <button
                        type="button"
                        className="text-xs border py-1 px-2 rounded-md flex justify-center items-center transition-all ease-linear duration-200 hover:bg-blue-400 hover:text-white hover:border-blue-400 hover:shadow"
                        onClick={() => handlePreviewData(note?.id)}
                      >
                        Preview
                      </button>
                    </div>
                  );
                })
              ) : (
                <div className="flex flex-col items-center justify-center gap-2 w-full">
                  <File />
                  <div className="flex flex-col gap-1 items-center justify-center">
                    <p className="text-[#131313CC] font-semibold text-sm">You didn't have any Notes</p>
                    <p className="text-[#131313CC] text-xs">List of notes will be diplayed here.</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Services */}
          <div
            className={`relative bg-white rounded-xl border hover:shadow-card border-gray-200 shadow ${services.length === 0 ? "h-[700px]" : "h-[180px]"} overflow-auto scrollbar-hidden`}
          >
            <h3 className="sticky top-0 text-lg font-semibold mb-3 bg-white p-5 border-b border-b-[#00000013]">
              Services
            </h3>
            <ul
              className={`px-5 pb-2.5 w-full ${services.length === 0 && "h-[620px]"} flex flex-col justify-center items-center gap-2`}
            >
              {services.length > 0 ? (
                services.map((s, i) => (
                  <li key={i} className="w-full flex justify-between items-center py-2 last:border-none">
                    <span>{s.name}</span>
                    <div className="flex items-center gap-2">
                      <span
                        className={`w-2 h-2 ${s.status === "Active" ? "bg-green-400" : "bg-red-500"} rounded-full `}
                      />
                      <span
                        className={`${s.status === "Active" ? "text-green-400" : "text-red-500"} text-sm font-medium`}
                      >
                        {s.status}
                      </span>
                    </div>
                  </li>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center gap-2 w-full">
                  <ServiceFile />
                  <div className="flex flex-col gap-1 items-center justify-center">
                    <p className="text-[#131313CC] font-semibold text-sm">You didn't have any Services</p>
                    <p className="text-[#131313CC] text-xs">List of services will be diplayed here.</p>
                  </div>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Notes Modal */}
      <Dialog open={isNotePreviewOpen} fullWidth maxWidth={"md"}>
        <NotesContentPreivew
          notesData={notes.filter((ele) => ele.id === noteId)}
          HandlePreviewData={handlePreviewData}
        />
      </Dialog>
    </div>
  );
};

export default Dashboard;
